import {
  ClipboardList,
  DocumentText,
  PresentationChartLine,
  Sparkles,
  ViewGrid,
} from "../../components/icons/svg/outline";

// Project page state and tab content.
export const DEFAULT_PROJECT_TAB = "overview";

export const EMPTY_TICKET_SUMMARY = {
  items: [],
  isLoading: false,
  error: null,
};

/**
 * Copy for Project Page surfaces that still use static labels.
 * Schedule/Dispatch embeds own their chrome; overview charts are live data.
 */
export const PROJECT_PAGE_PLACEHOLDER_CONTENT = {
  overview: {
    workerHours: {
      title: "Worker Hours",
      subtitle: "Signed payout timesheets",
    },
    concretePours: {
      title: "Concrete Pours",
      subtitle: "Daily Dispatch Assignments",
    },
    tmLog: {
      title: "T&M Log",
      subtitle: "Compact project T&M summary",
    },
    rfiLog: {
      title: "RFI Log",
      subtitle: "Compact project RFI summary",
    },
  },
  documents: {
    uploadTitle: "Upload Media",
    uploadSubtitle: "Add photos and video for this project",
    filesTitle: "Project Files",
    filesSubtitle: "Open curated Egnyte folders for this project",
  },
  assistant: {
    title: "Project AI Assistant",
    promptPrefix: "Ask questions about",
    includedDocumentsLabel: "Include documents",
    includedDocuments: [
      "HVAC_Plans_Rev3.pdf",
      "Building_Permit.pdf",
      "Scope_of_Work.docx",
    ],
    placeholder: "AI Assistant is coming soon",
    description: "Suggestions and project chat will be added in a later version.",
    inputPlaceholder: "Ask about this project...",
  },
};

/**
 * Exact Egnyte folder names for Project Documents links.
 * Must stay aligned with ``files.project_document_folders`` on the backend.
 * ``T&M RS App`` path is resolved on the backend (job root or under 07-PCOs*).
 */
export const PROJECT_DOCUMENT_FOLDER_NAMES = [
  "091-Photos",
  "092-Daily Reports",
  "093-Sign-In Sheets",
  "094-Site Safety Forms",
  "06-RFIs",
  "T&M RS App",
];

/** Egnyte web UI deep-link prefix (FS path including leading ``/`` is appended). */
export const EGNYTE_WEB_FILES_BASE =
  "https://rscminc.egnyte.com/app/index.do#storage/files/1";

export const PROJECT_TABS = [
  {
    id: "overview",
    label: "Overview",
    Icon: ViewGrid,
  },
  {
    id: "schedule",
    label: "Schedule",
    Icon: PresentationChartLine,
  },
  {
    id: "dispatch",
    label: "Dispatch",
    Icon: ClipboardList,
  },
  {
    id: "documents",
    label: "Documents",
    Icon: DocumentText,
  },
  {
    id: "assistant",
    label: "AI Assistant",
    Icon: Sparkles,
  },
];

// Embedded planning module settings.
// Schedule uses full editable Schedule with a soft default project filter.
// compact / readOnly / singleProject remain available but unused here.
export const PROJECT_SCHEDULE_EMBED_CONFIG = {
  compact: false,
  readOnly: false,
  singleProject: false,
  useDefaultProjectFilter: true,
  /** Timeline starts one week before the current week. */
  timelineStartOffsetWeeks: -1,
  showPageChrome: false,
};

// Compact Dispatch: hide SummaryBar/filters, show one project, editable details view.
export const PROJECT_DISPATCH_EMBED_CONFIG = {
  compact: true,
  readOnly: false,
  singleProject: true,
  detailsOnly: true,
  loadDayDetails: true,
  loadWeather: false,
};

// Projects home settings.
export const PROJECTS_HOME_DOCUMENT_TITLE = "R&S Projects";
export const PROJECTS_HOME_SEARCH_PLACEHOLDER = "Search projects...";
export const PROJECTS_HOME_ADD_PROJECT_LABEL = "Add New Project";
export const PROJECTS_HOME_VIEW_MODES = {
  LIST: "list",
  CARD: "card",
};
export const PROJECTS_HOME_DEFAULT_VIEW = PROJECTS_HOME_VIEW_MODES.CARD;
/** localStorage key for the Projects Home list/card view preference. */
export const PROJECTS_HOME_VIEW_STORAGE_KEY = "projectsHome.viewMode";
export const PROJECTS_HOME_FILTERS = [
  {
    key: "showCompletedProjects",
    id: "show-completed-projects",
    label: "Show Inactive Projects",
    active: true,
    defaultValue: false,
  },
];
/** Default empty values for the Projects Home date-range filter. */
export const PROJECTS_HOME_DATE_RANGE_DEFAULTS = {
  start: "",
  end: "",
};
export const PROJECTS_HOME_DATE_RANGE_FILTER = {
  id: "project-date-range",
  label: "Show projects within date range",
  startLabel: "Start",
  endLabel: "End",
};
/** Multi-select filter metadata for customer / manager filters. */
export const PROJECTS_HOME_MULTI_SELECT_FILTERS = {
  customers: {
    id: "project-customers",
    label: "Customer",
    placeholder: "Search customers...",
    emptyPlaceholder: "All customers",
  },
  managers: {
    id: "project-managers",
    label: "Manager(s)",
    placeholder: "Search managers...",
    emptyPlaceholder: "All managers",
  },
};

// Project header settings.
export const PROJECT_HEADER_SCROLL_COLLAPSE_THRESHOLD = 4;

